import * as constants from './constants';
import * as slice from './slice';
import sagas from './saga';

const creditCardService = { constants, ...slice, sagas };

export default creditCardService;

